export const txhhs = {
  agencyCode: '500',
  name: 'Texas Health and Human Services',
  shortName: 'TXHHS',
  slug: 'TXHHS',
};
